<template>
  <div>
		<div class="navbar">
			<b-button to="/" :data="data" :convertionsData="convertionsData" :applicationsData="applicationsData" :vCleanCodes="vCleanCodes" :competitorCodes="competitorCodes" variant="outline-light">
				NOVA PESQUISA
			</b-button>
		</div>
		<b-container>
			<b-row>
				<b-col cols="12">
					<span class="title">MARCA:</span>
					<span>{{ item && item.brand }}</span>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<span class="title">CÓDIGO CONCORRENTE:</span>
					<span>{{ item && item.competitorCode }}</span>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<span class="title">CÓDIGO VCLEAN:</span>
					<span>{{ item && item.vcleanCode }}</span>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12" :md="12">
					<b-card
						no-body
						:img-src="item.photo">

						<b-embed
							type="iframe"
							v-if="item.video"
							:src="item.video"
							allowfullscreen />
					</b-card>
				</b-col>
			</b-row>
		</b-container>
		<div id="modal" class="modal">
			<span class="modal-close">&times;</span>
			<img class="modal-content" id="modal-image">
		</div>
  </div>
</template>

<script>
export default {
	name: 'ConvertionsDetail',
	props: {
		code: String,
		data: Array,
		convertionsData: Array,
		applicationsData: Array,
		vCleanCodes: Array,
		competitorCodes: Array
	},

	data() {
		return {
			item: {},
			finalCode: ''
		};
	},

	methods: {
		init: function() {
			this.finalCode = this.code;
			if (this.code.includes('___')) {
				this.finalCode = this.finalCode.replace(/___/g, '/');
			}
			if (this.code.includes(';')) {
				this.finalCode = this.finalCode.replace(/;/g, ' ');
			}
			this.item = this.convertionsData.find(item => item.competitorCode.toUpperCase() === this.finalCode.toUpperCase());
		}
	},
	
	mounted() {
		this.init();
	}
};
</script>

<style scoped>
  input[type='text'] {
    margin-bottom: 15px;
  }
	.navbar {
		margin-bottom: 15px;
		background-color: #e9ecef;
		border: 1px solid #dfe4e8;
    border-radius: calc(0.25rem - 1px);
	}
	.title {
		font-weight: bold;
		margin-right: 5px;
	}
	.description {
		padding: 15px 10px;
	}
	.card {
		align-items: center;
		margin-top: 30px;
		padding: 10px;
	}
	.card-img {
		cursor: pointer;
		transition: 0.3s;
		width: 75%;
	}
	.card-img:hover {
		opacity: 0.8;
	}
	.column-header {
		width: 100%;
		font-weight: bold;
		padding: 5px 0;
		background-color: #e9ecef;
		border: 1px solid #dfe4e8;
		border-radius: calc(0.25rem - 1px);
		margin-bottom: 10px;
	}
	.column-header > span {
		display: block;
	}
	.column-header-title {
		padding-bottom: 10px;
		font-weight: bold;
	}
</style> -->
